import React, { Component } from 'react';
import { flow } from 'lodash';
import PropTypes from 'prop-types';
import { TweenLite } from 'gsap';
import withSlide from '../Slide';

// element heights in pixels
const animationElementWidth = 940;
const animationImageWidth = 1020;

class HorizontalPan extends Component {
  extraWidthPercentage =
    ((animationImageWidth - animationElementWidth) * 100) / animationImageWidth;

  componentDidMount() {
    const xPercent =
      this.props.panDirection === 'left'
        ? this.extraWidthPercentage
        : this.extraWidthPercentage * -1;

    this.tween = TweenLite.to(this.imgElement, this.props.duration, {
      paused: true,
      xPercent: xPercent
    });

    this.props.setGreensockObjectFunc(this.tween);
  }

  setImgRef = imgElement => {
    this.imgElement = imgElement;
  };

  render() {
    const imageClass =
      'slide__content__animation-type--HorizontalPan__img ' +
      'slide__content__animation-type--HorizontalPan__img--pan-direction-' +
      this.props.panDirection;

    return (
      <div className={this.props.classNameFunc('HorizontalPan')}>
        <img
          alt={this.props.imageAltText}
          className={imageClass}
          ref={this.setImgRef}
          src={this.props.image}
        />
      </div>
    );
  }
}

HorizontalPan.defaultProps = {
  panDirection: 'right',
  imageAltText: ''
};

HorizontalPan.propTypes = {
  classNameFunc: PropTypes.func.isRequired,
  duration: PropTypes.number.isRequired,
  image: PropTypes.string.isRequired,
  imageAltText: PropTypes.string,
  panDirection: PropTypes.oneOf(['left', 'right']),
  paused: PropTypes.bool.isRequired
};

export default flow(withSlide)(HorizontalPan);



// WEBPACK FOOTER //
// ../core/src/components/Slideshow/slideTypes/HorizontalPan.js